import React, {useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {sendVirtualPageView} from '../../../shared/utility';
import useJuryData from '../JuryProjectsList/useJuryData';
import useJuryStore from '../../../store/juryStore';
import JuryProjectsGrid from '../JuryProjectsList/JuryProjectsGrid';

function JuryBookmarks() {
    useJuryData(); // triggers one-time fetch

    const projects = useJuryStore(s => s.projects);
    const bookmarks = useJuryStore(s => s.bookmarks);
    const bookmarkedProjects = projects.filter(p => bookmarks.has(p._id));

    useEffect(() => {
        sendVirtualPageView("Jury - Merkliste");
    }, []);

    return (
        <>
            <Helmet>
                <title>Jury-Voting - Merkliste</title>
            </Helmet>
            <JuryProjectsGrid
                projects={bookmarkedProjects}
                showCount={false}
                emptyMessage="Markieren Sie Teilnehmer, die Ihnen gefallen, mit einem Stern und finden Sie sie hier wieder."
            />
        </>
    );
}

export default JuryBookmarks;
